import * as Realm from "realm-web";

// Set REACT_APP_REALM_APP_ID in your .env file
const app = new Realm.App({ id: process.env.REACT_APP_REALM_APP_ID });

export { Realm };
export default app;
